import { useFlash } from '../lib/liveMarket'
import { formatNumber } from '../lib/format'

/** A price that briefly flashes green/red when it changes (the ▲/▼ change text next to it carries the direction). */
export function LiveNumber({ value, decimals = 2, className, prefix = '' }: { value: number | null | undefined; decimals?: number; className?: string; prefix?: string }) {
  const flash = useFlash(value)
  return <span className={[className ?? '', flash ? `flash-${flash}` : ''].join(' ')}>{value == null ? '—' : `${prefix}${formatNumber(value, decimals)}`}</span>
}
